import NextImage from "next/image";
import { Box, Button, Heading, Stack, Text } from "@chakra-ui/react";

import { useTracking } from "contexts/Tracking";
import { setSessionRedirectPage } from "helpers/sessions";
import useRouter from "hooks/useRouter";
import { useDetailState } from "scenes/OfferDetail";
import { IMarginProps } from "src/types/types";
import { EOfferStatus } from "utils/offer";
import { useContactModal } from "modals/useContactModal";

const Contact: React.FC<IMarginProps> = ({ ...margins }) => {
  const { trackEvent } = useTracking();
  const { openModal: openContactModal } = useContactModal();

  const { navigateTo } = useRouter();

  const { offer, status } = useDetailState();

  return (
    <Box {...margins}>
      {offer && status === EOfferStatus.ACTIVE ? (
        <>
          <Stack
            p="16px"
            borderWidth="1px"
            borderColor="ud-grey-300"
            borderRadius="6px"
            bg="ud-grey-100"
            spacing="24px"
            data-test="offerDetail.contact"
          >
            <Stack direction="row" data-test="offerDetail.contact.owner">
              <Box
                boxSize="50px"
                borderRadius="50%"
                overflow="hidden"
                position="relative"
                data-test="offerDetail.contact.owner.photo"
              >
                <NextImage
                  src={
                    offer?.owner?.photo ?? "/fe/img/common/default_avatar.png"
                  }
                  alt={`Fotka uživatele ${offer?.owner?.firstName} ${offer?.owner?.surname}`}
                  fill
                />
              </Box>
              <Stack spacing="0px" justify="center">
                <Heading
                  as="h3"
                  color="ud-grey-600"
                  data-test="offerDetail.contact.owner.name"
                >
                  {offer?.owner?.firstName || offer?.owner?.surname
                    ? `${offer.owner.firstName} ${offer.owner.surname}`
                    : "Jméno neuvedeno"}
                </Heading>
                <Text
                  variant="small_2"
                  data-test="offerDetail.contact.owner.type"
                >
                  {offer?.owner?.type}
                </Text>
              </Stack>
            </Stack>
            <Button
              data-test="offerDetail.contact.button"
              onClick={() => {
                setSessionRedirectPage(
                  `${document.location.origin}/inzerat/${
                    offer.seo
                  }/${offer?.id?.toString()}`,
                );
                trackEvent({
                  "dl.eCat": "bttn.clicked",
                  "dl.eAct": "offer_detail",
                  "dl.eLab": "Kontaktovat",
                  initiate_chekout: "",
                });

                offer.isContacted
                  ? navigateTo("/moje-schranka/[[...messages]]")
                  : openContactModal({
                      offerId: offer.id,
                      isSuspicious: offer.showScamWarning,
                      loginEvent: {
                        LOGIN: {
                          "dl.eAct": "login",
                          "dl.eLab": "Odeslání zprávy – detail inzerátu",
                          "dl.eCat": "",
                        },
                        REGISTRATION: {
                          "dl.eAct": "registration",
                          "dl.eLab": "Odeslání zprávy – detail inzerátu",
                          "dl.eCat": "",
                        },
                      },
                    });
              }}
            >
              {offer.isContacted ? "Už kontaktováno" : "Kontaktovat"}
            </Button>

            {offer.showScamWarning && (
              <Stack bg="ud-primary-250" borderRadius="6px" p="16px">
                <Text color="ud-primary" fontSize="14px" lineHeight="1.375em">
                  Tento inzerát byl nahlášen jako <strong>podvodný</strong>.
                  Buďte při komunikaci obezřetní.
                </Text>
              </Stack>
            )}
          </Stack>
          {/* {offer.adminUrl && (
            <Stack my="10px" direction="row" justify="center">
              <Button
                onClick={() =>
                  typeof window !== "undefined" &&
                  window.open(offer.adminUrl, "_blank")
                }
                leftIcon={<Document fillWith="white" />}
                w="100%"
              >
                Detail v adminu
              </Button>
            </Stack>
          )} */}
        </>
      ) : (
        <Stack direction="row" justify="center" alignItems="center">
          <Button
            as="strong"
            variant="gray"
            data-test="offerDetail.inactiveButton"
          >
            Inzerát není aktuální
          </Button>
        </Stack>
      )}
    </Box>
  );
};

export default Contact;
